(ns ui.view.card.decisions.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.decisions.model :as model]))

(rf/reg-event-fx
 ::set-decision-expanded
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as _ctx} {:keys [decision-id expanded?]}]]
   (let [update-fn (if expanded?
                     (fnil conj #{})
                     (fnil disj #{}))]
     {:db (update-in db (model/expanded-decisions-full-path card-state-path) update-fn decision-id)})))
